<template>
  <main class="ws">

<!-- ============ 首屏 ============ -->
<section class="lhero lhero--c lhero--p">
  <div class="wrap">
    <span class="hero-pill">{{ $t("给中国卖家") }}</span>
    <h1 class="lhero__title">{{ $t("你只管选品和定价，") }}<br class="br-m">{{ $t("其余我们办") }}</h1>
    <p class="lhero__sub">{{ $t("建站、翻译、运费、打面单、答客户——") }}<b>{{ $t("中间这些麻烦事，平台替你做了。") }}</b></p>
    <div class="btns">
      <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店，10 分钟看到你的店") }}</router-link>
      <a class="btn btn--ghost" href="#pains">{{ $t("先看看别人在卖什么") }}</a>
    </div>
    <p class="lhero__note">{{ $t("佣金低至 3% · 模板和翻译按套餐含 · 店铺和客户数据都归你") }}</p>
  </div>

  <div class="wrap hero__mock">
    <div class="mock">
      <div class="mock__bar">
        <span class="mock__dots"><i></i><i></i><i></i></span>
        <span class="mock__url"><i></i>sportyd.taoifydemo.com/admin/analytics</span>
      </div>
      <div class="mock__body mock__body--shot">
        <img class="mock__shot" src="/website/img/admin-dashboard.jpg" :alt="$t('Taoify 商家工作台 · 数据看板界面')" loading="lazy">
      </div>
    </div>
    <div class="mock__float">
      <span class="ico-badge ico-badge--sm" style="width:26px;height:26px;border-radius:8px"><svg class="ico" style="width:14px;height:14px"><use href="#i-globe"/></svg></span>
      <div class="mock__float-w">
        <div style="font-size:12px;color:#1A1626;font-weight:500">{{ $t("已上线 20 种语言站点") }}</div>
        <div style="font-size:10.5px;color:#9A9AA8">{{ $t("日本語 · Deutsch · Español …") }}</div>
      </div>
    </div>
  </div>
</section>

<!-- ============ 吉祥物引导 ============ -->
<div class="guide-band">
  <div class="wrap">
    <img class="guide__m" src="/website/img/tao-point.png" alt="">
    <div class="bubble">{{ $t("下面这六件事，你大概率会遇到其中三四件。") }}<b>{{ $t("遇到了再解决") }}</b>{{ $t("，不用现在全想明白。") }}</div>
  </div>
</div>

<!-- ============ 六件事 ============ -->
<section class="sec sec--gray" id="pains">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("开店前后，绕不开的六个问题") }}</span>
      <h2 class="sec__title">{{ $t("每一件都有现成的解法") }}</h2>
      <p class="sec__sub">{{ $t("上面是你会问的问题，中间是我们怎么接，下面是你最后得到什么。") }}</p>
    </div>

    <div class="pains">
      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-browser"/></svg></span>
          <span class="pain__no">01</span>
        </div>
        <h3 class="pain__q">{{ $t("没有技术团队，建站要外包？") }}</h3>
        <p class="pain__do">{{ $t("选一个模板，填店铺名和邮箱，十分钟就开了。想改哪里点哪里，不用发需求等排期。") }}</p>
        <p class="pain__res">{{ $t("10 分钟上线，改版不用排队") }}</p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-globe"/></svg></span>
          <span class="pain__no">02</span>
        </div>
        <h3 class="pain__q">{{ $t("不会外语，商品描述怎么写？") }}</h3>
        <p class="pain__do">{{ $t("20 种语言自动翻，翻得不顺的句子可以自己改。术语不会被翻歪，尺码表也是对的。") }}</p>
        <p class="pain__res">{{ $t("日本客户看日文，德国客户看德文") }}</p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-truck"/></svg></span>
          <span class="pain__no">03</span>
        </div>
        <h3 class="pain__q">{{ $t("运费到底收多少，才不亏？") }}</h3>
        <p class="pain__do">{{ $t("按重量和地区设好模板，客户下单时系统自动算。偏远地区单独加价，不用你手算。") }}</p>
        <p class="pain__res">{{ $t("不再出现「运费比货贵」") }}</p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-card"/></svg></span>
          <span class="pain__no">04</span>
        </div>
        <h3 class="pain__q">{{ $t("客户想刷卡，我只收过微信？") }}</h3>
        <p class="pain__do">{{ $t("PayPal、Stripe、支付宝接上即用，外币直接进你的账户，平台不代收货款。") }}</p>
        <p class="pain__res">{{ $t("结账页多三种付法，少一次流失") }}</p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-box"/></svg></span>
          <span class="pain__no">05</span>
        </div>
        <h3 class="pain__q">{{ $t("国际快递怎么发，单号怎么回传？") }}</h3>
        <p class="pain__do">{{ $t("云途、燕文、4PX 实时比价，选一条就出单。面单批量打完，轨迹自动回到订单里。") }}</p>
        <p class="pain__res">{{ $t("一张面单贴完，客户自己查轨迹") }}</p>
      </article>

      <article class="pain">
        <div class="pain__top">
          <span class="ico-badge ico-badge--sm"><svg class="ico"><use href="#i-chat"/></svg></span>
          <span class="pain__no">06</span>
        </div>
        <h3 class="pain__q">{{ $t("客户半夜问东问西，谁来回？") }}</h3>
        <p class="pain__do">{{ $t("AI 员工按你定的规则答，答不了的转给你。时差不用熬，第二天看记录就行。") }}</p>
        <p class="pain__res">{{ $t("询盘不隔夜，退换不乱承诺") }}</p>
      </article>
    </div>
  </div>
</section>

<!-- ============ 最后一公里 ============ -->
<section class="sec sec--ink" id="lastmile">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("全链路") }}</span>
      <h2 class="sec__title">{{ $t("你的活到「交给快递」为止") }}</h2>
      <p class="sec__sub">{{ $t("后面这一段，是大多数人卡住的地方。我们把它接走。") }}</p>
    </div>

    <div class="flow">
      <div class="flow__node flow__node--you">
        <div class="flow__icon"><svg class="ico"><use href="#i-box"/></svg></div>
        <em>{{ $t("你的货") }}</em>
        <p>{{ $t("工厂或仓库里") }}<br>{{ $t("现成的那批货") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-grid"/></svg></div>
        <em>{{ $t("上架") }}</em>
        <p>{{ $t("一键铺货") }}<br>{{ $t("20 语种自动翻译") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-card"/></svg></div>
        <em>{{ $t("收款") }}</em>
        <p>{{ $t("外币进账") }}<br>{{ $t("不经过平台") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-warehouse"/></svg></div>
        <em>{{ $t("国内仓") }}</em>
        <p>{{ $t("你发到仓") }}<br>{{ $t("验货合箱") }}</p>
      </div>
      <div class="flow__arrow">→</div>
      <div class="flow__node flow__node--us">
        <div class="flow__icon"><svg class="ico"><use href="#i-plane"/></svg></div>
        <em>{{ $t("出境派送") }}</em>
        <p>{{ $t("报关、干线") }}<br>{{ $t("末端签收") }}</p>
      </div>
    </div>

    <div class="flow__legend" style="margin-top:34px">
      <i>{{ $t("紫色：平台负责") }}</i>
      <i class="grey">{{ $t("灰色：你负责") }}</i>
    </div>

    <div style="text-align:center;margin-top:38px">
      <router-link class="btn btn--ghost" to="/logistics">{{ $t("看物流怎么走") }}</router-link>
    </div>
  </div>
</section>

<!-- ============ 获客 ============ -->
<section class="sec" id="growth">
  <div class="wrap">
    <div class="frow">
      <div>
        <span class="frow__tag">{{ $t("获客") }}</span>
        <h2 class="frow__t">{{ $t("店开好了，客户从哪来") }}</h2>
        <p class="frow__d">{{ $t("这是第二道坎。Taoify 接上豆包这类 AI，先诊断你的店哪里不对劲，再给一份 30 天能照着做的计划，然后自动发到五个渠道。") }}</p>
        <ul class="frow__list">
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("店铺诊断：标题、图片、价格、转化，逐项说问题") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("Facebook、Instagram、TikTok 等 5 个渠道自动发") }}</span></li>
          <li><svg class="ico"><use href="#i-check"/></svg><span>{{ $t("每周回收数据，把预算挪到有反应的那条") }}</span></li>
        </ul>
        <router-link class="frow__link" to="/feature#growth">{{ $t("看 AI 营销怎么用") }}<svg class="ico"><use href="#i-arrow"/></svg></router-link>
      </div>
      <div class="frow__media">
        <div class="hl__visual">
          <img src="/website/img/Marketing-1.png" :alt="$t('多平台内容分发')">
        </div>
      </div>
    </div>
  </div>
</section>

<!-- ============ BuyLink ============ -->
<section class="sec sec--gray" id="buylink">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("更轻的起步方式") }}</span>
      <h2 class="sec__title">{{ $t("不想压货？先走代购") }}</h2>
      <p class="sec__sub">{{ $t("客户付外币，你只发国内快递。采购、集运、国际段都由平台办。") }}</p>
    </div>

    <div class="duo">
      <div class="duo__card">
        <span class="duo__step">{{ $t("第一档 · 起步用这个") }}</span>
        <div class="duo__icon"><svg class="ico"><use href="#i-box"/></svg></div>
        <h3 class="duo__t">{{ $t("代购模式") }}</h3>
        <p class="duo__d">{{ $t("不用备货、不用垫钱。客户下单后平台去买，你连货都不用碰。") }}</p>
        <ul class="duo__list">
          <li>{{ $t("零压货，卖什么买什么") }}</li>
          <li>{{ $t("外币收款由平台处理") }}</li>
          <li>{{ $t("适合刚起步、试品类") }}</li>
        </ul>
      </div>

      <div class="duo__mid"><span>{{ $t("跑通之后") }}</span><i>→</i></div>

      <div class="duo__card duo__card--accent">
        <span class="duo__step">{{ $t("第二档 · 放量用这个") }}</span>
        <div class="duo__icon"><svg class="ico"><use href="#i-layers"/></svg></div>
        <h3 class="duo__t">BuyLink {{ $t("模式") }}</h3>
        <p class="duo__d">{{ $t("店铺直接收外币，采购、集运、出国际单都由平台办。你只负责选品和发国内快递。") }}</p>
        <ul class="duo__list">
          <li>{{ $t("利润归你，价格自己定") }}</li>
          <li>{{ $t("多件合箱，运费更省") }}</li>
          <li>{{ $t("适合已有稳定货源") }}</li>
        </ul>
      </div>
    </div>

    <div class="aside__card" style="max-width:760px;margin:40px auto 0">
      <h5>{{ $t("客户那一端看到的是这样") }}</h5>
      <div class="aside__step"><i>1</i><span>{{ $t("在你的店铺看到商品，价格是你定的") }}</span></div>
      <div class="aside__step"><i>2</i><span>{{ $t("点「代购下单」，跳到代购平台，链接已预填") }}</span></div>
      <div class="aside__step"><i>3</i><span>{{ $t("平台买手回你的店下普通国内订单") }}</span></div>
      <div class="aside__step"><i>4</i><span>{{ $t("你发国内快递到平台仓，国际段平台负责") }}</span></div>
      <div style="margin-top:18px;padding-top:16px;border-top:1px dashed var(--line);font-size:12.5px;color:var(--muted);line-height:1.65">
        {{ $t("跑通了想自己赚利润，再切成 BuyLink 模式：店铺直接收外币，采购、集运、出国际单都由平台办。") }}
      </div>
    </div>
  </div>
</section>

<!-- ============ 对比 ============ -->
<section class="sec" id="cmp">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("三条路") }}</span>
      <h2 class="sec__title">{{ $t("自己搭、找外包、用 Taoify") }}</h2>
      <p class="sec__sub">{{ $t("不比参数，比的是「多久能开卖」和「出问题谁管」。") }}</p>
    </div>

    <div class="cmp-wrap">
      <table class="cmp">
        <thead>
          <tr><th>{{ $t("对比项") }}</th><th>{{ $t("自己搭") }}</th><th>{{ $t("找外包") }}</th><th class="us">Taoify</th></tr>
        </thead>
        <tbody>
          <tr><td><span class="cmp__k"><svg class="ico"><use href="#i-clock"/></svg>{{ $t("上线时间") }}</span></td><td class="dim">{{ $t("1–2 个月") }}</td><td class="dim">{{ $t("2–4 周，改一次再等一周") }}</td><td class="us">{{ $t("当天") }}</td></tr>
          <tr><td><span class="cmp__k"><svg class="ico"><use href="#i-wallet"/></svg>{{ $t("前期投入") }}</span></td><td class="dim">{{ $t("服务器、插件、维护，几千起") }}</td><td class="dim">{{ $t("几万起") }}</td><td class="us">{{ $t("佣金 3%–6%，按月成交额阶梯") }}</td></tr>
          <tr><td><span class="cmp__k"><svg class="ico"><use href="#i-cursor"/></svg>{{ $t("改一次样式") }}</span></td><td class="dim">{{ $t("找人重做") }}</td><td class="dim">{{ $t("再付一次钱") }}</td><td class="us">{{ $t("自己点两下，或跟 AI 说一句") }}</td></tr>
          <tr><td><span class="cmp__k"><svg class="ico"><use href="#i-globe"/></svg>{{ $t("多语言") }}</span></td><td class="dim">{{ $t("装插件，翻译另买") }}</td><td class="dim">{{ $t("加钱，通常只做一两种") }}</td><td class="us">{{ $t("20 种语言内置，自动切换") }}</td></tr>
          <tr><td><span class="cmp__k"><svg class="ico"><use href="#i-card"/></svg>{{ $t("收款") }}</span></td><td class="dim">{{ $t("自己申请，被拒就卡住") }}</td><td class="dim">{{ $t("自己申请") }}</td><td class="us">{{ $t("PayPal、Stripe、支付宝接上即用") }}</td></tr>
          <tr><td><span class="cmp__k"><svg class="ico"><use href="#i-truck"/></svg>{{ $t("国际物流") }}</span></td><td class="dim">{{ $t("自己找货代、自己算价") }}</td><td class="dim">{{ $t("不在服务范围") }}</td><td class="us">{{ $t("云途、燕文、4PX 已接，自动比价出单") }}</td></tr>
          <tr><td><span class="cmp__k"><svg class="ico"><use href="#i-horn"/></svg>{{ $t("获客") }}</span></td><td class="dim">{{ $t("自己摸索") }}</td><td class="dim">{{ $t("不在服务范围") }}</td><td class="us">{{ $t("AI 诊断 + 30 天方案 + 五渠道") }}</td></tr>
          <tr><td><span class="cmp__k"><svg class="ico"><use href="#i-user"/></svg>{{ $t("客户归属") }}</span></td><td class="dim">{{ $t("你的") }}</td><td class="dim">{{ $t("你的") }}</td><td class="us">{{ $t("你的，邮箱和订单数据都在你后台") }}</td></tr>
        </tbody>
      </table>
    </div>
    <p class="cmp__note">{{ $t("对比基于常见方案的平均情况，不代表任何具体服务商。") }}</p>
  </div>
</section>

<!-- ============ 三步 ============ -->
<section class="sec sec--gray">
  <div class="wrap">
    <div class="sec__head">
      <span class="eyebrow">{{ $t("怎么开始") }}</span>
      <h2 class="sec__title">{{ $t("三步，今天就能走完第一步") }}</h2>
    </div>

    <div class="start">
      <div class="start__item">
        <span class="start__no">01</span>
        <h4>{{ $t("开店") }}</h4>
        <p>{{ $t("填店铺名和邮箱，选一个模板。不用绑卡，不签合同。") }}</p>
        <span class="start__time">{{ $t("约 10 分钟") }}</span>
      </div>
      <div class="start__item">
        <span class="start__no">02</span>
        <h4>{{ $t("上架") }}</h4>
        <p>{{ $t("粘 1688 或淘宝链接，或用 Excel 批量导入。价格自己定。") }}</p>
        <span class="start__time">{{ $t("约 1 小时") }}</span>
      </div>
      <div class="start__item">
        <span class="start__no">03</span>
        <h4>{{ $t("出第一单") }}</h4>
        <p>{{ $t("把链接发到你已有的群或朋友圈，或者让 AI 帮你发到海外渠道。") }}</p>
        <span class="start__time">{{ $t("看你自己") }}</span>
      </div>
    </div>
  </div>
</section>

<!-- ============ 结论条 ============ -->

<section class="sec sec--tight">
  <div class="wrap">
    <div class="pandy">
      <img class="pandy__m" src="/website/img/tao-point.png" alt="">
      <div>
        <p class="pandy__t">{{ $t("不用一次全准备好") }}</p>
        <p class="pandy__b">{{ $t("很多人以为要先把货备齐、把公司注册好、把英文练好。其实") }}<b>{{ $t("先上十个商品试一个月") }}</b>{{ $t("，你会发现问题根本不在这些地方。") }}</p>
      </div>
    </div>
  </div>
</section>

<section class="sec sec--tight">
  <div class="wrap">
    <div class="band">
      <div>
        <h2 class="band__t">{{ $t("先开一间，比想清楚更重要") }}</h2>
        <p class="band__d">{{ $t("免费的，不绑卡。跑通一单再决定要不要花钱。") }}</p>
      </div>
      <router-link class="btn btn--primary" to="/sign-up">{{ $t("免费开店") }}</router-link>
    </div>
  </div>
</section>

</main>
</template>

<script>
export default {
  name: 'WebsiteForChinaSellers',
}
</script>
